/** 後端 PhotoConverter 的單一尺寸資訊 */
export interface PhotoSizeInterface {
  url: string
  path: string
  height: number
  width: number
}

/** 後端 PhotoConverter 回傳的圖片資料結構（avatar、banner 等欄位都用此格式） */
export interface PhotoDataInterface {
  name: string
  uid: string
  crop?: boolean
  size_list: Record<string, PhotoSizeInterface>
}

/** 圖片欄位的可能型別：純 URL 字串、PhotoConverter 物件、或空 */
export type PhotoValueType = string | PhotoDataInterface | null | undefined

/**
 * 從圖片欄位資料中取出 URL，支援字串與 PhotoConverter 物件兩種格式。
 *
 * @param value 圖片欄位資料
 * @param size  優先取此 size 的 url（預設 'origin'），找不到時 fallback 到任一可用 size
 */
export function photoUrl(value: PhotoValueType, size: string = 'origin'): string | null {
  if (!value) return null
  if (typeof value === 'string') return value
  const list = value.size_list
  if (!list) return null
  return list[size]?.url ?? list.origin?.url ?? Object.values(list)[0]?.url ?? null
}

/**
 * 從圖片欄位資料中取出檔案名稱，僅 PhotoConverter 物件才有 name；
 * 純 URL 字串（如 legacy 舊資料）取不到，回 null。
 */
export function photoName(value: PhotoValueType): string | null {
  if (!value || typeof value === 'string') return null
  return value.name || null
}
